export const MASCOTE_SPACE_TCHAU = "/assets/space/mascote_space_tchau.png";
